import type { SVGProps } from 'react'

const SvgRevert = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path
          d="M12 21.788C10.6167 21.788 9.31667 21.5255 8.1 21.0005C6.88333 20.4755 5.825 19.763 4.925 18.863C4.025 17.963 3.3125 16.9047 2.7875 15.688C2.2625 14.4713 2 13.1713 2 11.788C2 10.4047 2.2625 9.10465 2.7875 7.88799C3.3125 6.67132 4.025 5.61299 4.925 4.71299C5.825 3.81299 6.88333 3.10049 8.1 2.57549C9.31667 2.05049 10.6167 1.78799 12 1.78799C13.3833 1.78799 14.6833 2.05049 15.9 2.57549C17.1167 3.10049 18.175 3.81299 19.075 4.71299C19.975 5.61299 20.6875 6.67132 21.2125 7.88799C21.7375 9.10465 22 10.4047 22 11.788C22 13.1713 21.7375 14.4713 21.2125 15.688C20.6875 16.9047 19.975 17.963 19.075 18.863C18.175 19.763 17.1167 20.4755 15.9 21.0005C14.6833 21.5255 13.3833 21.788 12 21.788ZM12 19.788C14.2333 19.788 16.125 19.013 17.675 17.463C19.225 15.913 20 14.0213 20 11.788C20 9.55466 19.225 7.66299 17.675 6.11299C16.125 4.56299 14.2333 3.78799 12 3.78799C9.76667 3.78799 7.875 4.56299 6.325 6.11299C4.775 7.66299 4 9.55466 4 11.788C4 14.0213 4.775 15.913 6.325 17.463C7.875 19.013 9.76667 19.788 12 19.788Z"
          fill="#D0AF36"
        />
        <path
          d="M8.875 16V14.8H13.3125C13.9688 14.8 14.5391 14.6 15.0234 14.2C15.5078 13.8 15.75 13.3 15.75 12.7C15.75 12.1 15.5078 11.6 15.0234 11.2C14.5391 10.8 13.9688 10.6 13.3125 10.6H9.375L11 12.16L10.125 13L7 10L10.125 7L11 7.84L9.375 9.4H13.3125C14.3229 9.4 15.1901 9.715 15.9141 10.345C16.638 10.975 17 11.76 17 12.7C17 13.64 16.638 14.425 15.9141 15.055C15.1901 15.685 14.3229 16 13.3125 16H8.875Z"
          fill="#D0AF36"
          stroke="#D0AF36"
          //   stroke-width="0.4"
        />
      </g>
      <defs>
        <clipPath id="clip0_5862_19169">
          <rect width="24" height="24.0005" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default SvgRevert
